import { useMutation, useQueryClient } from '@tanstack/react-query';
import { configSIService } from '../../services/configSIService';
import type { ConfigRegrasCliente } from '../../models/config.types';
import { SI_CONFIG_QUERY_KEYS } from './useConfigSIQuery';
import { useToast } from '@/hooks/useToast';

/** Escrita de configuração do SI — exclusivo de si_admin (ver firestore.rules). */
export function useConfigSIMutations() {
  const queryClient = useQueryClient();
  const toast = useToast();

  const atualizarRegrasCliente = useMutation({
    mutationFn: ({ clienteId, ...dados }: { clienteId: string } & Omit<ConfigRegrasCliente, 'clienteId'>) =>
      configSIService.setRegrasCliente(clienteId, dados),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: SI_CONFIG_QUERY_KEYS.regrasCliente }),
    onError: (error: any) => {
      toast.error(`Erro ao salvar configuração: ${error?.message || 'erro desconhecido'}`);
    },
  });

  return { atualizarRegrasCliente };
}
